import {useEffect, useState} from 'react';
import {ButtonCopyToClipboard} from './ButtonCopyToClipboard';
import './CodeRecipe.scss';

type Props = {
	fileLocation: string;
	title: string;
};

export const CodeRecipe = (props: Props) => {
	const [textLoaded, setTextLoaded] = useState<string>('');
	const readFile = () => {
		return () => {
			fetch(props.fileLocation)
				.then((r) => r.text())
				.then((text) => {
					setTextLoaded(text);
				});
		};
	};
	useEffect(() => {
		console.log('Props has been changed... Reload file');
		readFile()();
	}, [props]);

	useEffect(() => {
		readFile()();
	}, [readFile]);
	return (
		<div className='panel'>
			<div className='recipe-wrapper'>
				<div className='recipe-header'>{props.title}</div>
				<div className='code recipe-text'>
					<textarea readOnly value={textLoaded} />
				</div>
				<div>
					<ButtonCopyToClipboard text={textLoaded} />
				</div>
			</div>
		</div>
	);
};
